import {Box, Center, Text} from '@chakra-ui/react';

interface QuoteBlockBannerProps {
  quote: string;
  cite?: string;
  background: string;
}

export const QuoteBlockBanner: React.FC<QuoteBlockBannerProps> = ({
  quote,
  cite,
  background,
}) => (
  <Center
    bg={background}
    textAlign="center"
    pt={{base: '86px', lg: '94px', xl: '109px'}}
    pb={{base: '86px', md: '97px', xl: '88px'}}
    px="45px"
    borderTop="2px solid"
    borderBottom="2px solid"
    borderColor="buttonGrey"
  >
    <Box color="darkGrey" maxW={{base: '523px', lg: '730px'}}>
      <Text textStyle={{base: 'body2_1c', md: 'h5_1c'}} textAlign="left">
        {quote}
      </Text>
      <Text textStyle="body4_1c" textAlign="right" mt={4}>
        {cite}
      </Text>
    </Box>
  </Center>
);
